import React, { useState } from "react";
import Button from "../../components/Button";

import CashPopup from "../../support-extra/components/CashPopup";

import { selectedOptic } from "../../js/utils";

import "../../support-extra/css/PopupMessage.css";

import moment from "moment";

export default function Settings(props) {
  const [showCashPopupEstandar, setShowCashPopupEstandar] = useState(false);
  const [showCashPopupDetallada, setShowCashPopupDetallada] = useState(false);
  const [showCashPopupMovimientos, setShowCashPopupMovimientos] =
    useState(false);

  const openCashPopupEstandar = (show) => {
    setShowCashPopupEstandar(show);
  };

  const openCashPopupDetallada = (show) => {
    setShowCashPopupDetallada(show);
  };

  const openCashPopupMovimientos = (show) => {
    setShowCashPopupMovimientos(show);
  };

  if (!props.show) {
    return <></>;
  }

  return (
    <>
      <div className="patient-data">
        <div className="patient-data-header">
          <span className="header-text">Cash popup</span>
          <div className="patient-header-buttons"></div>
        </div>
        <div className="patient-data-content">
          <div className="action-bar">
            <div className="action-bar-resume">
              <span>Debug</span>
              <span>|</span>
              <span className="signed-text">Cash popup</span>
            </div>
            <button
              className="action-bar-return"
              onClick={() => {
                props.onGoBack();
              }}
            >
              <span>Volver</span>
              <img
                src="/images/return.svg"
                loading="lazy"
                alt="Icon"
                className="return-icon"
              />
            </button>
          </div>
          <div className="patient-sections">
            <div className="patient-section">
              <div className="section-content">
                <div className="section-todo-tests">
                  <Button
                    title="Caja estándar"
                    onPress={() => openCashPopupEstandar(true)}
                  />
                  <span style={{ marginRight: 10 }} />
                  <Button
                    title="Caja detallada"
                    onPress={() => openCashPopupDetallada(true)}
                  />
                  <span style={{ marginRight: 10 }} />
                  <Button
                    title="Movimientos caja"
                    onPress={() => openCashPopupMovimientos(true)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <CashPopup
        opticaId={selectedOptic.id}
        fechaInicio={moment().format("YYYY-MM-DD")}
        fechaFin={moment().format("YYYY-MM-DD")}
        tipo="estandar"
        show={showCashPopupEstandar}
        onClose={() => openCashPopupEstandar(false)}
        createPopupQuestion={props.createPopupQuestion}
        removePopupQuestion={props.removePopupQuestion}
      />
      <CashPopup
        opticaId={selectedOptic.id}
        fechaInicio={moment().format("YYYY-MM-DD")}
        fechaFin={moment().format("YYYY-MM-DD")}
        tipo="detallada"
        show={showCashPopupDetallada}
        onClose={() => openCashPopupDetallada(false)}
        createPopupQuestion={props.createPopupQuestion}
        removePopupQuestion={props.removePopupQuestion}
      />
      <CashPopup
        opticaId={selectedOptic.id}
        fechaInicio={moment().format("YYYY-MM-DD")}
        fechaFin={moment().format("YYYY-MM-DD")}
        tipo="movimientos"
        show={showCashPopupMovimientos}
        onClose={() => openCashPopupMovimientos(false)}
        createPopupQuestion={props.createPopupQuestion}
        removePopupQuestion={props.removePopupQuestion}
      />
    </>
  );
}
